<ng-template #primaryMenuItems>
  <a [routerLink]="machinesRoute" role="menuitem" class="menu-item"
    [class.menu-item-active]="activeRoute === machinesRoute || activeRoute === homeRoute"
    (click)="onMenuItemSelected()">
    <div class="menu-item-content">
      <fa-icon [icon]="getIcon(machinesRoute, 'machines')"></fa-icon>
      <div class="menu-item-label">Maskiner</div>
    </div>
  </a>
  <a [routerLink]="teamsRoute" role="menuitem" class="menu-item" [class.menu-item-active]="activeRoute === teamsRoute"
    (click)="onMenuItemSelected()">
    <div class="menu-item-content">
      <fa-icon [icon]="getIcon(teamsRoute, 'teams')"></fa-icon>
      <div class="menu-item-label">Maskinlag</div>
    </div>
  </a>
  <a [routerLink]="contractorsRoute" role="menuitem" class="menu-item"
    [class.menu-item-active]="activeRoute === contractorsRoute" (click)="onMenuItemSelected()">
    <div class="menu-item-content">
      <fa-icon [icon]="getIcon(contractorsRoute, 'contractors')"></fa-icon>
      <div class="menu-item-label">Entreprenörer</div>
    </div>
  </a>
  @if(isPolicyPT || isPolicyPTAdmin || isPolicyDeveloper){
  <a [routerLink]="definitionValuesRoute" role="menuitem" class="menu-item"
    [class.menu-item-active]="activeRoute === definitionValuesRoute" (click)="onMenuItemSelected()">
    <div class="menu-item-content">
      <fa-icon [icon]="getIcon(definitionValuesRoute, 'definitions')"></fa-icon>
      <div class="menu-item-label">Registervård</div>
    </div>
  </a>
  }
  @if(isPolicyPTAdmin || isPolicyDeveloper) {
  <a [routerLink]="machinePerformancesRoute" role="menuitem" class="menu-item"
    [class.menu-item-active]="activeRoute === machinePerformancesRoute" (click)="onMenuItemSelected()">
    <div class="menu-item-content">
      <fa-icon [icon]="getIcon(machinePerformancesRoute, 'performances')"></fa-icon>
      <div class="menu-item-label">Maskinprestation</div>
    </div>
  </a>
  }
  @if(isPolicyPTAdmin || isPolicyDeveloper) {
  <a [routerLink]="userRoute" role="menuitem" class="menu-item" [class.menu-item-active]="activeRoute === userRoute"
    (click)="onMenuItemSelected()">
    <div class="menu-item-content">
      <fa-icon [icon]="getIcon(userRoute, 'users')"></fa-icon>
      <div class="menu-item-label">Användare</div>
    </div>
  </a>
  }
</ng-template>

<div class="menu" [class.menu-mobile-active]="isMobile()">
  @if (!isMobile()) {
  <nav class="menu-desktop" role="navigation" aria-label="Huvudmeny">
    <app-system-logo [size]="44" class="menu-logo"></app-system-logo>
    @if (showEnvironmentLabel) {
    <div class="environment-indicator menu-environment" [ngClass]="environmentBadgeClass">{{ environmentLabel }}</div>
    }

    <div class="menu-desktop-items" role="menu">
      <ng-container [ngTemplateOutlet]="primaryMenuItems"></ng-container>
    </div>

    <a [routerLink]="settingsRoute" role="menuitem" class="menu-item menu-item-user"
      [class.menu-item-active]="activeRoute === settingsRoute" (click)="onMenuItemSelected()">
      <div class="menu-item-content">
        <fa-icon [icon]="getIcon(settingsRoute, 'settings')"></fa-icon>
        <div class="menu-item-label">{{this.authService.userDetails().username}}</div>
      </div>
    </a>
  </nav>
  } @else {
  <div class="menu-mobile">
    <div class="menu-mobile-toggle-group">
      <button type="button" mat-fab class="menu-mobile-toggle" (click)="toggleMobileMenu()"
        [attr.aria-expanded]="isMobileMenuOpen()" aria-controls="mobile-main-menu"
        aria-label="Visa eller dölj huvudmenyn">
        <mat-icon>{{ isMobileMenuOpen() ? 'close' : 'menu' }}</mat-icon>
      </button>
      @if (showEnvironmentLabel) {
      <div class="environment-indicator menu-mobile-environment" aria-hidden="true" [ngClass]="environmentBadgeClass">{{
        environmentLabel }}</div>
      }
    </div>

    @if (isMobileMenuOpen()) {
    <div class="menu-mobile-backdrop" (click)="closeMobileMenu()" aria-hidden="true"></div>
    <nav id="mobile-main-menu" class="menu-mobile-sheet" role="menu" aria-label="Huvudmeny">
      <div class="menu-mobile-handle"></div>
      <div class="menu-mobile-header">
        <app-system-logo [size]="36" class="menu-logo"></app-system-logo>
        @if (showEnvironmentLabel) {
        <div class="environment-indicator menu-mobile-environment" [ngClass]="environmentBadgeClass">
          {{ environmentLabel }}
        </div>
        }
      </div>

      <div class="menu-mobile-body">
        <ng-container [ngTemplateOutlet]="primaryMenuItems"></ng-container>

        <a [routerLink]="settingsRoute" role="menuitem" class="menu-item"
          [class.menu-item-active]="activeRoute === settingsRoute" (click)="onMenuItemSelected()">
          <div class="menu-item-content">
            <fa-icon [icon]="getIcon(settingsRoute, 'settings')"></fa-icon>
            <div class="menu-item-label">{{this.authService.userDetails().username}}</div>
          </div>
        </a>
      </div>
    </nav>
    }
  </div>
  }
</div>